<template>
  <div class="Steps">
    <Container :mobile="mobile">
      <div>
        <Title :index="1">{{ $t('process.step_1_title') }}</Title>
        <StepText>
          {{ $t('process.step_1_text_1') }}
          <span class="highlight">
            <a :href="NETHERLANDS.externalFormCTALink">
              {{ $t('process.step_1_text_1_highlight') }}
            </a>
          </span>
        </StepText>
        <StepText>
          {{ $t('process.step_1_text_2') }}
        </StepText>
      </div>
      <AdaptiveWidth
        tiny="100px"
        xlarge="150px"
        huge="150px"
        :height="height"
      />
      <img src="../../../assets/processDescription/step/1.svg" />
    </Container>
    <Container :mobile="mobile" :reverse="true">
      <img src="../../../assets/processDescription/step/2.svg" />
      <AdaptiveWidth
        tiny="100px"
        xlarge="150px"
        huge="150px"
        :height="height"
      />
      <div>
        <Title :index="2">{{ $t('process.step_2_title') }}</Title>
        <StepText>{{ $t('process.step_2_text_1') }} </StepText>
      </div>
    </Container>
    <Container :mobile="mobile">
      <div>
        <Title :index="3">{{ $t('process.step_3_title') }}</Title>
        <StepText>{{ $t('process.step_3_text_1') }} </StepText>
      </div>
      <AdaptiveWidth
        tiny="100px"
        xlarge="150px"
        huge="150px"
        :height="height"
      />
      <img src="../../../assets/processDescription/step/3.svg" />
    </Container>
    <slot />
    <Container :mobile="mobile">
      <div>
        <Title :index="5">{{ $t('process.step_5_title') }}</Title>
        <StepText>{{ $t('process.step_5_text_1') }} </StepText>
      </div>
      <AdaptiveWidth
        tiny="100px"
        xlarge="150px"
        huge="150px"
        :height="height"
      />
      <img src="../../../assets/processDescription/step/5.svg" />
    </Container>
    <Container :mobile="mobile" :reverse="true">
      <img src="../../../assets/processDescription/step/6.svg" />
      <AdaptiveWidth
        tiny="100px"
        xlarge="150px"
        huge="150px"
        :height="height"
      />
      <div>
        <Title :index="6">{{ $t('process.step_6_title') }}</Title>
        <StepText>{{ $t('process.step_6_text_1') }} </StepText>
      </div>
    </Container>
    <AdaptiveHeight
      width="100%"
      tiny="100px"
      small="100px"
      medium="100px"
      large="100px"
      xlarge="150px"
      huge="190px"
    />
  </div>
</template>
<script>
import { NETHERLANDS } from '@/shared/entityHelpers';
import Title from './Title.vue';
import StepText from './Text.vue';
import Container from './Container.vue';
import AdaptiveWidth from '../../../layout/AdaptiveWidth.vue';
import AdaptiveHeight from '../../../layout/AdaptiveHeight.vue';

export default {
  components: { Title, StepText, Container, AdaptiveWidth, AdaptiveHeight },
  data() {
    return { mobile: window.innerWidth < 768, height: '50px', NETHERLANDS };
  },
  methods: {
    checkForMobile() {
      if (window.innerWidth < 768 && !this.mobile) {
        this.mobile = true;
        this.height = '50px';
        return;
      }
      if (window.innerWidth >= 768 && this.mobile) {
        this.mobile = false;
        this.height = '100%';
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkForMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkForMobile);
  },
};
</script>
<style scoped>
.Steps {
  margin: 0 auto;
  max-width: 85%;
}
img {
  max-width: 150px;
  margin: 0 auto;
}
.highlight {
  display: block;
  width: min-content;
  position: relative;
  text-decoration: underline;
  font: normal normal bold 16px/22px Lato;
  letter-spacing: 0.16px;
}
.highlight::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 15px;
  left: 0px;
  top: 55%;
  z-index: -1;
  background: var(--qwellow);
}
@media (min-width: 768px) {
  .Steps {
    max-width: 1200px;
  }
}
</style>
